import React, {useEffect} from "react";
import { connect } from "react-redux";
import $ from "jquery";

import {togglePulseFeatureInfoNote, togglePulseFeatureInfoQuantity} from "../../../actions/actionFunctions";
import {toggleProductNoteEditorVisible} from "../../../actions/selectionFunctions";
import {getCartItemObject} from "../../../misc/helpers";
import {getCurrentGroups} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";


export default (WrappedComponent) => {

  const WithMaterialsWizardFooterCommon = (props) => {

    const {selectionInfoQuantity, selectionFeatureInfo, togglePulseFeatureInfoQuantity, toggleProductNoteEditorVisible,
      relatedGroups, qtActiveCategory, selectionGroup, cartItems, cartItemEditFeature, activeQuoteIndex, togglePulseFeatureInfoNote,
      wizardActiveItem, wizardActiveStep, wizardSelectedValues} = props;

    useEffect(() => {
      togglePulseFeatureInfoQuantity(false);
      togglePulseFeatureInfoNote(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectionFeatureInfo])

    const quantityIsZero = () => {
      if (!selectionInfoQuantity && selectionFeatureInfo && !selectionFeatureInfo.dbFeature.hideQuantity) {
        togglePulseFeatureInfoQuantity(true);
        toggleProductNoteEditorVisible(false); // exit add note mode
        const $scrollableInfoArea = $(".selection-main__info-scrollable");
        if ($scrollableInfoArea) {
          $scrollableInfoArea.animate({scrollTop: 0}, 500);
        }
        return true;
      }
      return false
    }

    const noteIsRequired = () => {
      if (!wizardActiveItem) {
        return false
      }
      const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
      const wizardGroup = currentGroups[0];

      if (wizardGroup.noteIsRequired && selectionFeatureInfo && !selectionFeatureInfo.notesList[activeQuoteIndex]) {
        togglePulseFeatureInfoNote(true);
        toggleProductNoteEditorVisible(true); // exit add note mode
        const $scrollableInfoArea = $(".selection-main__info-scrollable");
        if ($scrollableInfoArea) {
          $scrollableInfoArea.animate({scrollTop: 0}, 500);
        }
        return true;
      }
      return false
    }

    const getCartFeatureParentName = (activeFeature) => {
      let parentName = selectionGroup;
      if (activeFeature.getParent) {
        const subPart = activeFeature.getParent();
        parentName = subPart.getParent ? subPart.getParent().partName : subPart.partName
      }
      return parentName
    }

    const getCurrentRelatedCartItems = (activeFeature, arrayToAddtoTheCart = []) => {
      if (Array.isArray(relatedGroups) && relatedGroups.length) {
        relatedGroups.forEach(relatedGroup => {
          relatedGroup.relatedFeatures.forEach(relatedFeature => {
            if (relatedFeature.cartQuantity && !(cartItemEditFeature && cartItems.some(cartItem => {
              return cartItem.cartFeature && (cartItem.cartFeature.dbFeature.id === relatedFeature.dbFeature.id)
                && cartItem.currentQuote === activeQuoteIndex && cartItem.quantity === relatedFeature.cartQuantity
            }))) { // prevent adding it once again if it was already added
              const relatedItemCartObject = getCartItemObject(relatedFeature, relatedFeature.cartQuantity, qtActiveCategory);
              relatedItemCartObject.relatedProductParent = activeFeature;
              arrayToAddtoTheCart.push(relatedItemCartObject)
            }
          });
        });
      }
      return arrayToAddtoTheCart
    }

    return <WrappedComponent {...props}
                             quantityIsZero={quantityIsZero}
                             noteIsRequired={noteIsRequired}
                             getCurrentRelatedCartItems={getCurrentRelatedCartItems}
                             getCartFeatureParentName={getCartFeatureParentName}/>

  };

  const mapStateToProps = (store) => {
    const {selectionFeatureInfo, selectionInfoQuantity, relatedGroups, selectionGroup} = store.selectionState;
    const {qtActiveCategory} = store.qtState;
    const {cartItems, cartItemEditFeature} = store.cartState;
    const {activeQuoteIndex} = store.quotesState;
    const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = store.wizardState;

    return {
      selectionFeatureInfo,
      selectionInfoQuantity,
      relatedGroups,
      qtActiveCategory,
      selectionGroup,
      cartItems,
      cartItemEditFeature,
      activeQuoteIndex,
      wizardActiveItem, wizardActiveStep, wizardSelectedValues,
    };
  };

  const mapDispatchToProps = {
    togglePulseFeatureInfoQuantity,
    toggleProductNoteEditorVisible,
    togglePulseFeatureInfoNote,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithMaterialsWizardFooterCommon)
}
